import script from "./NotFoundPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&setup=true&lang=js"

import "./NotFoundPage.vue?vue&type=style&index=0&id=25cf96f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25cf96f2"]])

export default __exports__